exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!sweetalert2/dist/sweetalert2.min.css"), "");

// module
exports.push([module.id, "\n.search-table[data-v-6e76775b] {\n  width: 300px;\n}\n.modal-header .close[data-v-6e76775b] {\n  margin-top: -20px;\n}\n.header-button-container[data-v-6e76775b] {\n  text-align: right;\n}\n.create-new-button[data-v-6e76775b] {\n  height: 100%;\n}\n.btn-primary[data-v-6e76775b] {\n  height: 37.5px;\n  border: 1px;\n}\n.fa-plus-circle[data-v-6e76775b] {\n  padding-top: 4.5px;\n}\n.vgt-checkbox-col[data-v-6e76775b] {\n  color: blue;\n}\n", ""]);

// exports
